module.exports = __webpack_public_path__ + "img/dental_red_tc.8d9eabb4.png";